import React, { useState } from 'react';
import tubbyOverlay from './../img/tubby-overlay.jpg';
import tubbyGelMani from './../img/tubby-gel-mani.jpg';
import tubbyGelExtensions from './../img/tubby-gel-extensions.jpg';
import tubbyNailArt from './../img/tubby-nail-art.jpg';
import { FaHandHoldingHeart } from "react-icons/fa";

const Services = () => {
  const servicesData = [
    {
      id: 1,
      name: 'Tubby Overlay',
      description: 'Add strength and durability to your natural nails. This is an add on to the Tubby Gel Mani.',
      price: 30,
      image: tubbyOverlay
    },
    {
      id: 2,
      name: 'Tubby Gel Mani',
      description: 'Dry manicure on natural nails. Includes detailed cuticle work with an efile. Includes 1 color of Korean or Japanese gel polish.',
      price: 60,
      image: tubbyGelMani
    },
    {
      id: 3,
      name: 'Gel Extensions',
      description: 'Offered in short-XXL length. This is an alternative to acrylic nails. Includes 1 color of Korean or Japanese gel polish (+ $10 for XL or longer).',
      price: 100,
      image: tubbyGelExtensions
    },
    {
      id: 4,
      name: 'Custom Art',
      description: 'Prices vary depending on design and how detailed/elaborate it is. Contact to receive a quote. Pictures for inspiration are strongly encouraged!',
      price: '40-100+',
      image: tubbyNailArt
    },
  ];

  const [selectedService, setSelectedService] = useState(servicesData[0]); // Initially select the first service

  const handleServiceClick = (service) => {
    setSelectedService(service);
  };

  return (
    <section className="services">
      <h2 className='artist-info'>
        Studio <span className='artist'>Services</span>
      </h2>
      <hr className='line' />
      <br />
      <div className="service-menu">
        {servicesData.map((service) => (
          <div
            key={service.id}
            className="service-menu-item"
            style={{
              backgroundColor: selectedService.id === service.id ? 'rgba(160, 160, 160, 0.235)' : 'transparent',
              cursor: 'pointer',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              padding: '10px',
              whiteSpace: 'nowrap',
            }}
            onClick={() => handleServiceClick(service)}
          >
            {service.name}
          </div>
        ))}
      </div>

      <div className="service-details">
        <img src={selectedService.image} alt={selectedService.name} className="details-image" />
        <p className="details-light">
          <br />
          {selectedService.description} 
          <br />
           <span className='details-price'>
            ${selectedService.price}
          </span>
        </p>
      </div>
    </section>
  );
};

export default Services;
